var render = function (_h,_vm) {var _c=_vm._c;return _c('h3',{staticClass:"subtitle-1 mb-3"},[_vm._t("default",[_vm._v(_vm._s(_vm.parent.$t(_vm.props.title)))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }